import React, { useEffect, useState } from 'react';

import styled from 'styled-components';

import { COMPANY_COMMUNITY_RELATION_TYPE } from 'constants/company';
import { CommunityType } from 'types/communities';
import { getCommunitiesByIds } from 'utils/helpers/communityMap';

import OverviewCommunitiesTableHeader from './OverviewCommunitiesTableHeader';
import OverviewCommunitiesTablePreview from './OverviewCommunitiesTablePreview';
import { useAppSelector } from '../../store/hook';

const Container = styled.div`
  border-radius: 16px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: #fff;
`;

interface Props {
  type: number;
  communities: CommunityType[];
}

const OverviewCommunitiesTable = ({ type, communities }: Props) => {
  const { communityMap } = useAppSelector((state) => state.global);
  const [filteredCommunities, setFilteredCommunities] = useState<any>([]);
  const [filterKeyword, setFilterKeyword] = useState<string>('');

  useEffect(() => {
    const adjustedFilterKeyword = filterKeyword?.toLowerCase();
    const filteredCommunities = (communities ?? []).filter(
      (community) =>
        community?.comunity_name?.toLowerCase().includes(adjustedFilterKeyword?.toLowerCase()) ||
        community?.address?.toLowerCase().includes(adjustedFilterKeyword?.toLowerCase())
    );
    if (type == COMPANY_COMMUNITY_RELATION_TYPE.COMMUNITY) {
      const updatedCommunities = filteredCommunities.map((community) => {
        const communityCompetitors = getCommunitiesByIds(communityMap, community.competitors).filter(
          (competitor: CommunityType | undefined) => !!competitor
        );

        return { ...community, children: communityCompetitors };
      });
      setFilteredCommunities(updatedCommunities);
    } else {
      setFilteredCommunities(filteredCommunities);
    }
  }, [communities, filterKeyword, type, communityMap]);

  return (
    <Container>
      <OverviewCommunitiesTableHeader type={type} handleSearch={setFilterKeyword} />
      <OverviewCommunitiesTablePreview type={type} communities={filteredCommunities} />
    </Container>
  );
};

export default OverviewCommunitiesTable;
